module.exports = ['config', 'Modal', function PlaylistShareModal(config, Modal) {
    var modal;

    return {
        open: function (params, data) {
            modal = Modal.create(
                config.templateRoot + '/templates/playlists/modals/share',
                params,
                data
            );

            return modal;
        },

        get: function () {
            return modal;
        }
    };
}];



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistclientbundle/Resources/js/angular/services/PlaylistShareModal.js